import React, { useEffect, useState } from "react";
import Table from "../../extra/Table";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import { useDispatch, useSelector } from "react-redux";
import {
  cleanAllPlanEarning,
  getAllPlanEarnings,
} from "../../store/admin/admin.action";
import dayjs from "dayjs";
import { getDefaultCurrency } from "../../store/currency/currency.action";
import LazyImage from "../../../common/ImageFallback";
import coin from "../../../assets/images/mcoin.png";
import { PAYMENT_GATEWAYS } from "../../../util/paymentGateways";
import UniqueIdCopy from "../../extra/UniqueIdCopy";

const AllPlanEarnings = (props) => {
  const { startDate, endDate } = props;

  const {
    allPlanEarning,
    allPlanTotal,
    allPlanTotalEarning,
    allPlanError,
  } = useSelector((state) => state.admin);

  const { defaultCurrency } = useSelector((state) => state.currency);

  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [search, setSearch] = useState("");
  const [paymentGateway, setPaymentGateway] = useState("All");

  useEffect(() => {
    dispatch(getDefaultCurrency());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllPlanEarnings(startDate, endDate, page, size, search, paymentGateway));

    return () => {
      dispatch(cleanAllPlanEarning());
    };
  }, [dispatch, startDate, endDate, page, size, search, paymentGateway]);

  useEffect(() => {
    setData(allPlanEarning || []);
  }, [allPlanEarning]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleServerSearch = (value) => {
    setPage(1);
    setSearch(value || "");
  };

  const getPlanTypeLabel = (row) => {
    const type = row?.type;

    if (type === 8 || type === "8") {
      return "Coin Plan";
    }
    if (type === 11 || type === "11") {
      return "VIP Plan";
    }

    return row?.planType || row?.planName || "-";
  };

  const earningTable = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="text-nowrap">
          {(page - 1) * size + parseInt(index, 10) + 1}
        </span>
      ),
    },
    {
      Header: "USERNAME",
      body: "userName",
      Cell: ({ row }) => {
        const user = row?.user || row;
        return (
          <div className="d-flex align-items-center">
            <LazyImage imageSrc={user?.image} width="50px" height="50px" />
            <div className="ms-3 ">
              {/* Nick Name */}
              <div className="fw-semibold text-start text-capitalize">
                {user?.fullName || "-"}
              </div>

              {/* Full Name */}
              <div className="text-muted small text-start text-capitalize">
                {user?.nickName || "-"}
              </div>

              <div className="text-muted small text-start text-capitalize"> <UniqueIdCopy value={user?.userUniqueId} placeholder="-" /></div>
            </div>
          </div>
        );
      },
    },
    {
      Header: "PLAN TYPE",
      body: "planType",
      Cell: ({ row }) => (
        <span className="text-capitalize">{getPlanTypeLabel(row)}</span>
      ),
    },
    {
      Header: "TRANSACTION ID",
      body: "uniqueId",
      Cell: ({ row }) => (
        <span>{row?.uniqueId || row?.transactionId || "-"}</span>
      ),
    },
    // {
    //   Header: "COINS",
    //   body: "coin",
    //   Cell: ({ row }) => (
    //     <div className="d-flex align-items-center justify-content-center gap-2">
    //       <img
    //         src={coin}
    //         alt="coin"
    //         style={{ width: "20px", height: "20px" }}
    //       />
    //       <span>{row?.coin ?? "-"}</span>
    //     </div>
    //   ),
    // },
    {
      Header: "PAYMENT GATEWAY",
      body: "paymentGateway",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.paymentGateway}</span>
      ),
    },
    {
      Header: "COINS",
      body: "coin",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center justify-content-center  gap-2">
          <img
            src={coin}
            alt="coin"
            style={{ width: "20px", height: "20px" }}
          />
          <span>{row?.coin}</span>
        </div>
      ),
    },

    {
      Header: "REWARD COINS",
      body: "rewardCoins",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center justify-content-center  gap-2">
          <img
            src={coin}
            alt="coin"
            style={{ width: "20px", height: "20px" }}
          />
          <span>{row?.rewardCoins}</span>
        </div>
      ),
    },
    {
      Header: `AMOUNT (${defaultCurrency?.symbol})`,
      body: "amount",
      Cell: ({ row }) => (
        <span>
          {row?.amount} {defaultCurrency?.symbol}
        </span>
      ),
    },


    {
      Header: "DATE",
      body: "date",
      Cell: ({ row }) => (
        <span>
          {dayjs(row?.createdAt || row?.date).format("MM/DD/YYYY hh:mm A")}
        </span>
      ),
    },
  ];

  return (
    <div className="">
      <div className="user-table">
        <div className="user-table-top">
          <div className="d-flex justify-content-between w-100">
            <div className="w-100">
              <h5
                style={{
                  fontWeight: "500",
                  fontSize: "20px",
                }}
                className="m-0"
              >
                Plan Earning
              </h5>
            </div>

            <div className="d-flex justify-content-end gap-2 w-100">
              <select
                className="form-select"
                style={{ maxWidth: 220 }}
                value={paymentGateway}
                onChange={(e) => {
                  setPage(1);
                  setPaymentGateway(e.target.value);
                }}
              >
                {PAYMENT_GATEWAYS.map((g) => (
                  <option key={g.value} value={g.value}>
                    {g.label}
                  </option>
                ))}
              </select>

              <Searching
                placeholder={"Search..."}
                type={"server"}
                serverSearching={handleServerSearch}
                setSearchData={setSearch}
                actionShow={false}
                inline={true}
                inputMaxWidth={280}
              />
            </div>

          </div>
        </div>



        <Table
          data={data}
          mapData={earningTable}
          serverPerPage={size}
          serverPage={page}
          type={"server"}
        />
        <div className="">
          <Pagination
            type={"server"}
            activePage={page}
            actionShow={false}
            rowsPerPage={size}
            userTotal={allPlanTotal}
            setPage={setPage}
            handleRowsPerPage={handleRowsPerPage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AllPlanEarnings;

